import { cn } from 'helpers/cn';
import { FOCUS_RING } from '../../ConsolePanel';

/**
 * Sentiment is not status: positive reads as ok, negative as danger, neutral as a
 * plain hairline chip. Nothing here is "broken", so danger is only lent to the
 * negative bucket because it is the one that needs finding.
 */
export const SENTIMENT_STYLES: Record<string, string> = {
  positive: 'text-ok border-ok-line',
  neutral: 'text-dim border-line',
  negative: 'text-danger bg-danger-bg border-danger-line',
};

export const CHIP = 'micro-label rounded-pill inline-flex items-center border px-2 py-0.5';

export const PANEL = 'bg-panel border-line rounded-panel border';
/** Title over its controls below `md`; a title plus five pills is not one 375px line. */
export const PANEL_HEAD = cn(
  'border-line flex flex-col gap-2 border-b px-4 py-3',
  'md:flex-row md:flex-wrap md:items-center md:justify-between',
);
export const PANEL_TITLE = 'text-foreground m-0 text-body font-medium';

/**
 * A filter pill.
 *
 * `border-input` on the unselected state: it carries no fill, so the outline is the
 * only thing drawing it, and `--line` is 10% alpha. `min-h-9` clears the 36px touch
 * floor on a phone.
 */
export const FILTER_PILL = cn(
  'micro-label rounded-pill flex min-h-9 shrink-0 items-center border px-2.5 py-1',
  'transition-colors duration-150 md:min-h-0',
  FOCUS_RING,
);
export const FILTER_PILL_ON = 'bg-sel-bg border-sel-line text-foreground';
export const FILTER_PILL_OFF = 'border-input text-dim hover:bg-hover hover:text-foreground';
